// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const packFrame = defineModel({
  id: "pack-frame",
  batchId: "future",
  name: "Pack frame",
  tags: ["scenery","pack","frame","low-poly","age-of-mcp","future"],
  summary: "A pack-saddle frame — straps cargo onto a pack animal.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.3,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.04, 0.56, 0.04), color: "#6e4f2e", position: [-0.02, 0.25, 0.14], rotation: [0.45, 0, 0.16] },
      { geometry: new THREE.BoxGeometry(0.04, 0.56, 0.04), color: "#6e4f2e", position: [-0.02, 0.25, -0.14], rotation: [-0.45, 0, 0.16] },
      { geometry: new THREE.BoxGeometry(0.04, 0.56, 0.04), color: "#6e4f2e", position: [0.02, 0.25, 0.14], rotation: [0.45, 0, -0.16] },
      { geometry: new THREE.BoxGeometry(0.04, 0.56, 0.04), color: "#6e4f2e", position: [0.02, 0.25, -0.16], rotation: [-0.45, 0, -0.16] },
      { geometry: new THREE.BoxGeometry(0.04, 0.04, 0.36), color: "#8a6840", position: [0, 0.42, 0] },
      { geometry: new THREE.SphereGeometry(0.13, 6, 5), color: "#c7b27a", position: [-0.16, 0.2, 0], scale: [1, 0.82, 1.08] },
      { geometry: new THREE.SphereGeometry(0.13, 6, 5), color: "#bba76e", position: [0.16, 0.2, 0], scale: [1, 0.82, 1.08] },
      { geometry: new THREE.BoxGeometry(0.2, 0.1, 0.14), color: "#a9763f", position: [0, 0.48, 0] },
    ],
  animations: [],
});
